import { getAction } from '@/api/manage';
import { getQiniuUrl, getQiniuFile } from '@/utils/qiniu.js';
export default {
  name: "SideMenuStudent",
  data: function data() {
    return {
      selectedKeys: ["course"],
      userCountInfo: {}
    };
  },
  computed: {
    avatarUrl: function avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        if (this.$store.state.user.info.thirdType == "cyscc") {
          return "https://cast-files.oss-cn-beijing.aliyuncs.com/" + this.$store.state.user.info.avatar;
        } else {
          return this.getQiniuUrl(this.$store.state.user.info.avatar);
        }
      } else {
        return "/img/avatar.png";
      }
    }
  },
  created: function created() {
    var that = this;
    this.userInfo = this.$store.state.user.info;
    this.selectedKeys[0] = this.$route.name;
    // this.getUserCount()
  },
  methods: {
    getQiniuUrl: getQiniuUrl,
    getQiniuFile: getQiniuFile
  }
};